export default "__VITE_ASSET__BZy7zlo6__"